/* eslint-disable react/no-danger */
import React from 'react';
import type { ItemDetailsProps } from '../../types';
import Text from '../../../../../ui/Text';
import * as Styles from './ItemDetailsStyles';

const ItemDetails: React.FC<ItemDetailsProps> = ({ item, canDispense }) => {
  const showItemCid = item.recipe?.code === 'C5' && !!item.cid;

  return (
    <Styles.ItemContent>
      {canDispense ? <Styles.Icon name="done-fill" checked={item.checked} /> : <Styles.EmptySpace />}
      <Styles.ItemDetailsWrapper>
        <Styles.Title color="black">
          {item.title}
          {item.quantity || item.unit ? ' - ' : ''}
          {item.quantity !== 0 ? item.quantity : ''}
          &nbsp;
          {item.unit}
        </Styles.Title>

        {item.compositions?.exist && (
          <Styles.CompositionsList
            // biome-ignore lint/security/noDangerouslySetInnerHtml: false positive
            dangerouslySetInnerHTML={{
              __html: item.compositions.items,
            }}
          />
        )}

        <Text color="black">{item.description}</Text>

        {showItemCid && (
          <Styles.CidBlock data-testid="item-cid-block">
            <Styles.CidDescription>
              <strong>CID: </strong>{item.cid.code} - {item.cid.description}
            </Styles.CidDescription>
          </Styles.CidBlock>
        )}
      </Styles.ItemDetailsWrapper>
    </Styles.ItemContent>
  );
};

export default ItemDetails;
